import apiFetch from '../../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `Intervencion/deleteSeleccionIntervencion`, method: 'POST', body: {list}, token: token})
}
